import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

export default injectIntl((props) => {
  // console.log(props);
  const { intl } = props;
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: (
            <div
              style={{ textAlign: "center", color: "blue", fontWeight: "bold" }}
            >
              <IntlMessages id="table.import.success" />:{" "}
              {props.dataSuccess.length} -{" "}
              <span
                style={{
                  textAlign: "center",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                <IntlMessages id="table.import.failed" />:{" "}
                {props.dataFailed.length}
              </span>
            </div>
          ),
          columns: [
            {
              Header: <IntlMessages id="stock.name" />,
              accessor: "name",
              minWidth: 150,
            },
            {
              Header: <IntlMessages id="stock.unit" />,
              accessor: "unit",
            },
            {
              Header: <IntlMessages id="warehouse.import-price" />,
              accessor: "price_new",
            },
            {
              Header: <IntlMessages id="warehouse.import-quantity" />,
              accessor: "count",
            },
            {
              Header: <IntlMessages id="stock.inventory" />,
              accessor: "inventory",
            },
            {
              Header: <IntlMessages id="stock.total-import" />,
              accessor: "total",
            },
          ],
        },
      ],
    });
  }, []);

  return (
    <ReactTable
      defaultPageSize={10}
      data={props.dataSuccess}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
});
